import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DateObject from "react-date-object";

export default class Task extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'task',
            id: this.props.Id,
            loading: true,
            lockScreen: 0,
            users: [],
            data: null,
            contracts: [],
            record: {
                id: 0,
                title: '',
                description: '',
                taskCategory: 1,
                contractId: null,
                assignedToUserId: null,
                supervisorUserId: null,
                priority: 1,
                status: 1,
                dueDate: null,
                startDate: null,
                completionDate: null,
                comments: [],
                documents: [],
                contractDetail: null,
                canEdit: true
            },
            activeTab: 'info',
            commentText: '',
            uploadDoc: { documentType: '', description: '', fileBase64: '', fileName: '' },
            canEditAll: false,
            canEditStatus: false
        };
    }

    componentDidMount() { this.loadData(); }

    async loadData() {
        const currentId = this.getCurrentFormId();
        this.httpPost(`api/v1/${this.state.controllerName}/get`, { id: currentId })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    const rec = data.record;

                    const toDateObj = (str) => {
                        if (!str) return null;
                        return new DateObject({
                            date: new Date(str),
                            calendar: persian,
                            locale: persian_fa
                        });
                    };
                    rec.dueDate = toDateObj(rec.dueDate);
                    rec.startDate = toDateObj(rec.startDate);
                    rec.completionDate = toDateObj(rec.completionDate);

                    const currentUser = data.global.user;
                    const isAdmin = currentUser.role === 1;
                    const isCreator = rec.createdByUserId === currentUser.id;
                    const isSupervisor = rec.supervisorUserId === currentUser.id;
                    const isAssignee = rec.assignedToUserId === currentUser.id;

                    const canEditAll = rec.createdByUserId === 0 ? true : isAdmin || isCreator || isSupervisor;
                    const canEditStatus = canEditAll || isAssignee;

                    this.setState({
                        record: rec,
                        users: data.users,
                        contracts: data.contracts,
                        loading: false,
                        data: data,
                        canEditAll,
                        canEditStatus
                    });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    handleChange(field, value) {
        this.setState({ record: { ...this.state.record, [field]: value } });
    }

    // انتخاب قرارداد با پر کردن خودکار عنوان (همانند NewTaskModal)
    handleContractChange = (e) => {
        const val = e.target.value ? parseInt(e.target.value) : null;
        this.handleChange('contractId', val);

        if (!val) {
            // در صورت نیاز می‌توانید عنوان را پاک کنید (اختیاری)
            return;
        }

        // فقط اگر عنوان خالی یا پیش‌فرض باشد، آن را پر می‌کنیم
        if (!this.state.record.title || this.state.record.title.startsWith('وظیفه برای')) {
            const selectedOption = e.target.options[e.target.selectedIndex].text;
            this.handleChange('title', `وظیفه برای ${selectedOption}`);
        }

        // دریافت جزئیات و به‌روزرسانی عنوان نهایی
        this.fetchContractInfo(val);
    };

    fetchContractInfo = (contractId) => {
        if (!contractId) return;
        this.httpPost('api/v1/contract/get', { id: contractId })
            .then(data => {
                if (data.status === 1) {
                    const c = data.record;
                    const servicesStr = (c.services && c.services.length > 0)
                        ? c.services.map(s => s.title).join('، ') : '';

                    const newTitle = `${servicesStr ? servicesStr + ' - ' : ''}${c.contractNumber} - وظیفه جدید`;

                    // به‌روزرسانی عنوان (اگر هنوز تغییر نکرده باشد)
                    this.setState(prevState => ({
                        record: {
                            ...prevState.record,
                            title: (!prevState.record.title || prevState.record.title.startsWith('وظیفه برای'))
                                ? newTitle
                                : prevState.record.title,
                            description: `🔹 شماره قرارداد: ${c.contractNumber}\n📅 بازه: ${c.startDate || '---'} تا ${c.endDate || '---'}\n💰 مبلغ: ${this.money(c.amount)} تومان`
                        }
                    }));
                }
            });
    };

    toISO(dateObj) {
        if (!dateObj) return '';
        return dateObj.toDate().toISOString().slice(0, 16);
    }

    async save(e) {
        e.preventDefault();
        const recordToSend = {
            ...this.state.record,
            dueDate: this.toISO(this.state.record.dueDate),
            startDate: this.toISO(this.state.record.startDate),
            completionDate: this.toISO(this.state.record.completionDate)
        };

        this.setState({ lockScreen: 1 });
        this.httpPost(`api/v1/${this.state.controllerName}/save`, recordToSend)
            .then(data => {
                this.setState({ lockScreen: 0 });
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage('وظیفه ذخیره شد');
                    this.setState({ redirect: '/tasks' });
                } else {
                    this.showErorrMessage(data.message);
                }
            });
    }

    addComment() {
        if (!this.state.commentText.trim()) return;
        this.httpPost(`api/v1/${this.state.controllerName}/addcomment`, {
            taskId: this.state.record.id,
            content: this.state.commentText
        }).then(data => {
            if (data.status === 1) {
                const comments = [...this.state.record.comments, data.comment];
                this.setState({ record: { ...this.state.record, comments }, commentText: '' });
            } else this.showErorrMessage(data.message);
        });
    }

    handleFileSelect(e) {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result.split(',')[1];
            this.setState({ uploadDoc: { ...this.state.uploadDoc, fileBase64: base64, fileName: file.name } });
        };
        reader.readAsDataURL(file);
    }

    uploadDocument() {
        if (!this.state.uploadDoc.fileBase64) return;
        this.httpPost(`api/v1/${this.state.controllerName}/uploaddocument`, {
            taskId: this.state.record.id,
            documentType: this.state.uploadDoc.documentType,
            description: this.state.uploadDoc.description,
            fileBase64: this.state.uploadDoc.fileBase64,
            fileName: this.state.uploadDoc.fileName
        }).then(data => {
            if (data.status === 1) {
                this.showSuccessMessage('مدرک آپلود شد');
                this.loadData();
                this.setState({ uploadDoc: { documentType: '', description: '', fileBase64: '', fileName: '' } });
            } else this.showErorrMessage(data.message);
        });
    }

    renderForm() {
        const { record, users, contracts, activeTab, commentText, uploadDoc, canEditAll, canEditStatus } = this.state;
        const isEdit = record.id > 0;
        const isCompleted = record.status === 5;

        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">
                                {isEdit ? `وظیفه: ${record.title}` : 'ایجاد وظیفه جدید'}
                            </h3>
                        </div>
                        <div className="nk-block-head-content">
                            <NavLink to="/tasks/" className="btn btn-dim btn-outline-light">
                                <em className="icon ni ni-arrow-left"></em><span>بازگشت</span>
                            </NavLink>
                        </div>
                    </div>
                </div>

                <div className="nk-block">
                    <div className="card card-bordered">
                        <div className="card-inner">
                            <ul className="nav nav-tabs">
                                <li className="nav-item">
                                    <a className={`nav-link ${activeTab === 'info' ? 'active' : ''}`}
                                        onClick={() => this.setState({ activeTab: 'info' })}>اطلاعات</a>
                                </li>
                                {isEdit && (
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeTab === 'comments' ? 'active' : ''}`}
                                            onClick={() => this.setState({ activeTab: 'comments' })}>
                                            مکالمات ({record.comments.length})
                                        </a>
                                    </li>
                                )}
                                {isEdit && (
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeTab === 'docs' ? 'active' : ''}`}
                                            onClick={() => this.setState({ activeTab: 'docs' })}>
                                            مدارک ({record.documents.length})
                                        </a>
                                    </li>
                                )}
                                {isEdit && record.taskCategory === 2 && record.contractDetail && (
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeTab === 'contract' ? 'active' : ''}`}
                                            onClick={() => this.setState({ activeTab: 'contract' })}>
                                            اطلاعات قرارداد
                                        </a>
                                    </li>
                                )}
                            </ul>
                            <div className="mt-3">
                                {activeTab === 'info' && (
                                    <form onSubmit={e => this.save(e)}>
                                        <div className="row g-4">
                                            {/* عنوان */}
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">عنوان <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control"
                                                        value={record.title}
                                                        onChange={e => this.handleChange('title', e.target.value)}
                                                        disabled={!canEditAll} />
                                                </div>
                                            </div>
                                            {/* نوع وظیفه */}
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">نوع وظیفه</label>
                                                    <select className="form-select"
                                                        value={record.taskCategory}
                                                        onChange={e => this.handleChange('taskCategory', parseInt(e.target.value))}
                                                        disabled={!canEditAll}>
                                                        <option value="1">داخلی</option>
                                                        <option value="2">قراردادی</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {record.taskCategory === 2 && (
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-label">قرارداد</label>
                                                        <select className="form-select"
                                                            value={record.contractId || ''}
                                                            onChange={this.handleContractChange}
                                                            disabled={!canEditAll}>
                                                            <option value="">-- انتخاب --</option>
                                                            {contracts.map(c => <option key={c.id} value={c.id}>{c.title}</option>)}
                                                        </select>
                                                    </div>
                                                </div>
                                            )}
                                            {/* مجری */}
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">مجری</label>
                                                    <select className="form-select"
                                                        value={record.assignedToUserId || ''}
                                                        onChange={e => this.handleChange('assignedToUserId', e.target.value ? parseInt(e.target.value) : null)}
                                                        disabled={!canEditAll}>
                                                        <option value="">-- انتخاب --</option>
                                                        {users.map(u => <option key={u.id} value={u.id}>{u.fullName}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                            {/* سرپرست */}
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">سرپرست</label>
                                                    <select className="form-select"
                                                        value={record.supervisorUserId || ''}
                                                        onChange={e => this.handleChange('supervisorUserId', e.target.value ? parseInt(e.target.value) : null)}
                                                        disabled={!canEditAll}>
                                                        <option value="">-- انتخاب --</option>
                                                        {users.map(u => <option key={u.id} value={u.id}>{u.fullName}</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                            {/* اولویت */}
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">اولویت</label>
                                                    <select className="form-select"
                                                        value={record.priority}
                                                        onChange={e => this.handleChange('priority', parseInt(e.target.value))}
                                                        disabled={!canEditAll}>
                                                        <option value="1">کم</option>
                                                        <option value="2">متوسط</option>
                                                        <option value="3">زیاد</option>
                                                        <option value="4">حیاتی</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {/* وضعیت */}
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">وضعیت</label>
                                                    <select className="form-select"
                                                        value={record.status}
                                                        onChange={e => this.handleChange('status', parseInt(e.target.value))}
                                                        disabled={!canEditStatus || isCompleted}>
                                                        <option value="1">جدید</option>
                                                        <option value="2">در حال انجام</option>
                                                        <option value="3">نیازمند مدارک</option>
                                                        <option value="4">بررسی سرپرست</option>
                                                        <option value="5">تکمیل شده</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {/* سررسید */}
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">سررسید <span className="text-danger">*</span></label>
                                                    <DatePicker
                                                        calendar={persian}
                                                        locale={persian_fa}
                                                        value={record.dueDate}
                                                        onChange={date => this.handleChange('dueDate', date)}
                                                        format="YYYY/MM/DD HH:mm"
                                                        plugins={[<TimePicker position="bottom" />]}
                                                        inputClass="form-control"
                                                        disabled={!canEditAll}
                                                    />
                                                </div>
                                            </div>
                                            {/* تاریخ شروع */}
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">تاریخ شروع</label>
                                                    <DatePicker
                                                        calendar={persian}
                                                        locale={persian_fa}
                                                        value={record.startDate}
                                                        onChange={date => this.handleChange('startDate', date)}
                                                        format="YYYY/MM/DD HH:mm"
                                                        plugins={[<TimePicker position="bottom" />]}
                                                        inputClass="form-control"
                                                        disabled={!canEditAll}
                                                    />
                                                </div>
                                            </div>
                                            {/* تاریخ تکمیل */}
                                            <div className="col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label">تاریخ تکمیل</label>
                                                    <DatePicker
                                                        calendar={persian}
                                                        locale={persian_fa}
                                                        value={record.completionDate}
                                                        onChange={date => this.handleChange('completionDate', date)}
                                                        format="YYYY/MM/DD HH:mm"
                                                        plugins={[<TimePicker position="bottom" />]}
                                                        inputClass="form-control"
                                                        disabled={!canEditAll}
                                                    />
                                                </div>
                                            </div>
                                            {/* توضیحات */}
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-label">توضیحات</label>
                                                    <textarea className="form-control" rows="4"
                                                        value={record.description}
                                                        onChange={e => this.handleChange('description', e.target.value)}
                                                        disabled={!canEditAll}></textarea>
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                {canEditAll && (
                                                    <button type="submit" className="btn btn-primary" disabled={this.state.lockScreen === 1}>
                                                        <em className="icon ni ni-save"></em> ذخیره
                                                    </button>
                                                )}
                                                <NavLink to="/tasks/" className="btn btn-dim btn-outline-light ms-2">
                                                    <em className="icon ni ni-cross"></em> {canEditAll ? 'انصراف' : 'بازگشت'}
                                                </NavLink>
                                            </div>
                                        </div>
                                    </form>
                                )}

                                {activeTab === 'comments' && (
                                    <div>
                                        <div className="mb-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            {record.comments.map(c => (
                                                <div key={c.id} className="mb-3">
                                                    <strong>{c.userName}</strong> - {c.createdDatePersian}
                                                    <p>{c.content}</p>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="input-group">
                                            <input className="form-control" value={commentText}
                                                onChange={e => this.setState({ commentText: e.target.value })}
                                                placeholder="پیام خود را بنویسید..." />
                                            <button className="btn btn-primary" onClick={() => this.addComment()}>ارسال</button>
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'docs' && (
                                    <div>
                                        <h5>مدارک پیوست</h5>
                                        <table className="table table-bordered">
                                            <thead><tr><th>نوع</th><th>نام فایل</th><th>توضیح</th><th>تاریخ</th><th>دانلود</th></tr></thead>
                                            <tbody>
                                                {record.documents.map(d => (
                                                    <tr key={d.id}>
                                                        <td>{d.documentType}</td>
                                                        <td>{d.fileName}</td>
                                                        <td>{d.description}</td>
                                                        <td>{d.uploadDatePersian}</td>
                                                        <td><a href={`/api/v1/task/download/${d.id}`} target="_blank" className="btn btn-sm btn-primary"><em className="icon ni ni-download"></em></a></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <hr />
                                        <div className="card card-bordered p-3">
                                            <div className="row g-3">
                                                <div className="col-md-4"><input className="form-control" placeholder="نوع مدرک" value={uploadDoc.documentType} onChange={e => this.setState({ uploadDoc: { ...uploadDoc, documentType: e.target.value } })} /></div>
                                                <div className="col-md-4"><input className="form-control" placeholder="توضیح" value={uploadDoc.description} onChange={e => this.setState({ uploadDoc: { ...uploadDoc, description: e.target.value } })} /></div>
                                                <div className="col-md-4"><input type="file" className="form-control" onChange={e => this.handleFileSelect(e)} /></div>
                                                <div className="col-12"><button className="btn btn-success" onClick={() => this.uploadDocument()}>آپلود</button></div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {activeTab === 'contract' && record.contractDetail && (
                                    <div>
                                        <h5>{record.contractDetail.customerName} - {record.contractDetail.contractNumber}</h5>
                                        <p>مبلغ کل: {this.money(record.contractDetail.amount)} | پرداخت شده: {this.money(record.contractDetail.paidAmount)} | بدهی: {this.money(record.contractDetail.debtAmount)}</p>
                                        <h6>خدمات تحت پوشش</h6>
                                        <ul>
                                            {record.contractDetail.services.map(s => <li key={s.id}>{s.title}</li>)}
                                        </ul>
                                        <h6>پرداخت‌ها</h6>
                                        <table className="table table-bordered">
                                            <thead><tr><th>تاریخ</th><th>مبلغ</th><th>توضیح</th><th>وضعیت</th></tr></thead>
                                            <tbody>
                                                {record.contractDetail.payments.map(p => (
                                                    <tr key={p.id}>
                                                        <td>{p.paymentDatePersian}</td>
                                                        <td>{this.money(p.amount)}</td>
                                                        <td>{p.description}</td>
                                                        <td>{p.isReceived ? 'دریافت شده' : 'معوق'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            <Header data={{ global: this.state.data?.global }} />,
            <div className="nk-content "><div className="container-fluid"><div className="nk-content-inner">{this.renderForm()}</div></div></div>,
            <Footer />
        ];
        return contents;
    }
}